/** Base URL for API calls. Empty in dev (Vite proxy), absolute URL in production. */
export const API_BASE = import.meta.env.VITE_API_URL || "";
